var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKiosk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 213.333H224C229.896 213.333 234.667 208.562 234.667 202.666V138.666C234.667 132.77 229.896 127.999 224 127.999H160C154.104 127.999 149.333 132.77 149.333 138.666V202.666C149.333 208.563 154.104 213.333 160 213.333Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M277.333 202.667C277.333 208.563 282.104 213.334 288 213.334H352C357.896 213.334 362.667 208.563 362.667 202.667V138.667C362.667 132.771 357.896 128 352 128H288C282.104 128 277.333 132.771 277.333 138.667V202.667Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160 341.333H224C229.896 341.333 234.667 336.562 234.667 330.666V266.666C234.667 260.77 229.896 255.999 224 255.999H160C154.104 255.999 149.333 260.77 149.333 266.666V330.666C149.333 336.563 154.104 341.333 160 341.333Z",
    fill: "#BDBDBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M352 256H288C282.104 256 277.333 260.771 277.333 266.667V330.667C277.333 336.563 282.104 341.334 288 341.334H352C357.896 341.334 362.667 336.563 362.667 330.667V266.667C362.667 260.771 357.896 256 352 256Z",
    fill: "#BDBDBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.333 85.333H266.666C272.562 85.333 277.333 80.562 277.333 74.666C277.333 68.77 272.562 63.999 266.666 63.999H245.333C239.437 63.999 234.666 68.77 234.666 74.666C234.667 80.563 239.438 85.333 245.333 85.333Z",
    fill: "#BDBDBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M384 0H128C104.469 0 85.333 19.135 85.333 42.667V469.334C85.333 492.865 104.469 512 128 512H384C407.531 512 426.667 492.865 426.667 469.333V42.667C426.667 19.135 407.531 0 384 0ZM288 469.333H224C218.104 469.333 213.333 464.562 213.333 458.666C213.333 452.77 218.104 448 224 448H288C293.896 448 298.667 452.771 298.667 458.667C298.667 464.563 293.896 469.333 288 469.333ZM384 405.333H128V42.667H384V405.333Z",
    fill: "#BDBDBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M352 85.334C357.891 85.334 362.667 80.5582 362.667 74.667C362.667 68.7758 357.891 64 352 64C346.109 64 341.333 68.7758 341.333 74.667C341.333 80.5582 346.109 85.334 352 85.334Z",
    fill: "#BDBDBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosk);
export default __webpack_public_path__ + "static/media/kiosk.a07e1c04.svg";
export { ForwardRef as ReactComponent };